//# sourceMappingURL=docx.mjs.map
/// <reference types="./docx.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $html_parser from "../common/html_parser.mjs";
import * as $processing from "../data/docx/block_processing.mjs";
import * as $document_context from "../data/docx/document_context.mjs";
import * as $img from "../data/docx/image.mjs";
import * as $kind from "../data/docx/kind.mjs";
import * as $hr from "../data/docx/page_break.mjs";
import * as $p from "../data/docx/paragraph.mjs";
import * as $table from "../data/docx/table.mjs";
import * as $text from "../data/docx/text.mjs";
import * as $block from "../data/proposal_element/block.mjs";
import * as $element_outline from "../data/proposal_element/outline.mjs";
import * as $question from "../data/proposal_element/question.mjs";
import * as $element_table from "../data/proposal_element/table.mjs";
import * as $language from "../data/translate/language.mjs";
import * as $iso639 from "../data/translate/language/iso639.mjs";
import {
  Ok,
  Error,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
  isEqual,
} from "../gleam.mjs";

const FILEPATH = "src/data/docx.gleam";

export class Docx extends $CustomType {
  constructor(language, elements) {
    super();
    this.language = language;
    this.elements = elements;
  }
}
export const Docx$Docx = (language, elements) => new Docx(language, elements);
export const Docx$isDocx = (value) => value instanceof Docx;
export const Docx$Docx$language = (value) => value.language;
export const Docx$Docx$0 = (value) => value.language;
export const Docx$Docx$elements = (value) => value.elements;
export const Docx$Docx$1 = (value) => value.elements;

export class PageBreak extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Element$PageBreak = ($0) => new PageBreak($0);
export const Element$isPageBreak = (value) => value instanceof PageBreak;
export const Element$PageBreak$0 = (value) => value[0];

export class Paragraph extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Element$Paragraph = ($0) => new Paragraph($0);
export const Element$isParagraph = (value) => value instanceof Paragraph;
export const Element$Paragraph$0 = (value) => value[0];

export class Table extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Element$Table = ($0) => new Table($0);
export const Element$isTable = (value) => value instanceof Table;
export const Element$Table$0 = (value) => value[0];

export class Image extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Element$Image = ($0) => new Image($0);
export const Element$isImage = (value) => value instanceof Image;
export const Element$Image$0 = (value) => value[0];

export class BlockProcessing extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Element$BlockProcessing = ($0) => new BlockProcessing($0);
export const Element$isBlockProcessing = (value) =>
  value instanceof BlockProcessing;
export const Element$BlockProcessing$0 = (value) => value[0];

export function element_decoder() {
  return $decode.field(
    "type",
    $decode.string,
    (type_) => {
      if (type_ === "table") {
        let _pipe = $table.decoder();
        return $decode.map(_pipe, (var0) => { return new Table(var0); });
      } else if (type_ === "page_break") {
        let _pipe = $hr.decoder();
        return $decode.map(_pipe, (var0) => { return new PageBreak(var0); });
      } else if (type_ === "paragraph") {
        let _pipe = $p.decoder();
        return $decode.map(_pipe, (var0) => { return new Paragraph(var0); });
      } else if (type_ === "image") {
        let _pipe = $img.decoder();
        return $decode.map(_pipe, (var0) => { return new Image(var0); });
      } else if (type_ === "block-processing") {
        let _pipe = $processing.decoder();
        return $decode.map(
          _pipe,
          (var0) => { return new BlockProcessing(var0); },
        );
      } else if (type_ === "break") {
        let _pipe = $hr.decoder();
        return $decode.map(_pipe, (var0) => { return new PageBreak(var0); });
      } else if (type_ === "block_processing") {
        let _pipe = $processing.decoder();
        return $decode.map(
          _pipe,
          (var0) => { return new BlockProcessing(var0); },
        );
      } else {
        let metadata = new $hr.Metadata(new None());
        let context = new $document_context.FromDocx();
        let _pipe = new Some(
          new $document_context.DocumentContext(
            "",
            0,
            context,
            new None(),
            new None(),
          ),
        );
        let _pipe$1 = new $hr.PageBreak(_pipe, new $hr.Page(), "", metadata);
        let _pipe$2 = new PageBreak(_pipe$1);
        return $decode.failure(_pipe$2, "Unknown element type");
      }
    },
  );
}

export function decoder() {
  return $decode.field(
    "language",
    $iso639.decoder(),
    (language) => {
      return $decode.field(
        "elements",
        $decode.list(element_decoder()),
        (elements) => { return $decode.success(new Docx(language, elements)); },
      );
    },
  );
}

export function encode_element(element) {
  if (element instanceof PageBreak) {
    let pb = element[0];
    return $hr.encode(pb);
  } else if (element instanceof Paragraph) {
    let p = element[0];
    return $p.encode(p);
  } else if (element instanceof Table) {
    let t = element[0];
    return $table.encode(t);
  } else if (element instanceof Image) {
    let i = element[0];
    return $img.encode(i);
  } else {
    let b = element[0];
    return $processing.encode(b);
  }
}

export function encode(docx) {
  return $json.object(
    toList([
      ["elements", $json.array(docx.elements, encode_element)],
      ["language", $json.string($iso639.to_string(docx.language))],
    ]),
  );
}

export function encode_styles(styles) {
  return $json.object(
    $list.map(
      styles,
      (_use0) => {
        let style = _use0[0];
        let value = _use0[1];
        return [style, $json.string(value)];
      },
    ),
  );
}

export function to_html(docx) {
  return $list.map(
    docx.elements,
    (element) => {
      if (element instanceof PageBreak) {
        let page_break = element[0];
        return $hr.to_html(page_break);
      } else if (element instanceof Paragraph) {
        let paragraph = element[0];
        return $p.to_html(paragraph);
      } else if (element instanceof Table) {
        let table = element[0];
        return $table.to_html(table);
      } else if (element instanceof Image) {
        let image = element[0];
        return $img.to_html(image);
      } else {
        let block_processing = element[0];
        return $processing.to_html(block_processing);
      }
    },
  );
}

function element_to_labelling(element) {
  if (element instanceof PageBreak) {
    let page_break = element[0];
    return toList([$hr.to_html(page_break)]);
  } else if (element instanceof Paragraph) {
    let paragraph = element[0];
    return $p.to_labelling(paragraph);
  } else if (element instanceof Table) {
    let table = element[0];
    let $ = $table.is_empty(table);
    if ($) {
      return toList([]);
    } else {
      return toList([$table.to_labelling(table)]);
    }
  } else if (element instanceof Image) {
    let image = element[0];
    return toList([$img.to_html(image)]);
  } else {
    let block_processing = element[0];
    return toList([$processing.to_html(block_processing)]);
  }
}

export function to_labelling(docx) {
  return $list.flat_map(docx.elements, element_to_labelling);
}

export function id(docx) {
  if (docx instanceof PageBreak) {
    return new None();
  } else if (docx instanceof Paragraph) {
    let p = docx[0];
    return new Some(p.doc_context.id);
  } else if (docx instanceof Table) {
    return new None();
  } else if (docx instanceof Image) {
    return new None();
  } else {
    return new None();
  }
}

export function update_kind(element, kind) {
  if (element instanceof PageBreak) {
    let p = element[0];
    return new PageBreak($hr.update_kind(p, kind));
  } else if (element instanceof Paragraph) {
    let p = element[0];
    return new Paragraph($p.update_kind(p, kind));
  } else if (element instanceof Table) {
    let t = element[0];
    return new Table($table.update_kind(t, kind));
  } else if (element instanceof Image) {
    let i = element[0];
    return new Image($img.update_kind(i, kind));
  } else {
    let b = element[0];
    return new BlockProcessing($processing.update_kind(b, kind));
  }
}

export function kind(element) {
  let _block;
  if (element instanceof PageBreak) {
    let p = element[0];
    _block = p.metadata.kind;
  } else if (element instanceof Paragraph) {
    let p = element[0];
    _block = p.metadata.kind;
  } else if (element instanceof Table) {
    let t = element[0];
    _block = t.metadata.kind;
  } else if (element instanceof Image) {
    let i = element[0];
    _block = i.metadata.kind;
  } else {
    let b = element[0];
    _block = b.metadata.kind;
  }
  let _pipe = _block;
  return $option.unwrap(_pipe, new $kind.Other());
}

export function index(element) {
  if (element instanceof PageBreak) {
    let p = element[0];
    let $ = p.doc_context;
    if ($ instanceof Some) {
      let doc_context = $[0];
      return new Some(doc_context.index);
    } else {
      return $;
    }
  } else if (element instanceof Paragraph) {
    let p = element[0];
    return new Some(p.doc_context.index);
  } else if (element instanceof Table) {
    let t = element[0];
    return new Some(t.doc_context.index);
  } else if (element instanceof Image) {
    let i = element[0];
    let $ = i.doc_context;
    if ($ instanceof Some) {
      let doc_context = $[0];
      return new Some(doc_context.index);
    } else {
      return $;
    }
  } else {
    let b = element[0];
    return new Some(b.doc_context.index);
  }
}

export function from_block(block) {
  let $ = $html_parser.as_tree(("<div>" + block.content) + "</div>");
  let nodes;
  if ($ instanceof $html_parser.StartElement) {
    nodes = $;
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "data/docx",
      169,
      "from_block",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 4846,
        end: 4958,
        pattern_start: 4857,
        pattern_end: 4894
      }
    )
  }
  return $list.filter_map(
    nodes.children,
    (child) => {
      let html = $html_parser.render_html(child, 0);
      let _block;
      let _pipe = $hr.from_html(html);
      _block = $result.map(_pipe, (var0) => { return new PageBreak(var0); });
      let _pipe$1 = _block;
      let _pipe$2 = $result.lazy_or(
        _pipe$1,
        () => {
          let _pipe$2 = $table.from_html(html);
          return $result.map(_pipe$2, (var0) => { return new Table(var0); });
        },
      );
      let _pipe$3 = $result.lazy_or(
        _pipe$2,
        () => {
          let _pipe$3 = $img.from_html(html);
          return $result.map(_pipe$3, (var0) => { return new Image(var0); });
        },
      );
      let _pipe$4 = $result.lazy_or(
        _pipe$3,
        () => {
          let _pipe$4 = $p.from_html(html);
          return $result.map(_pipe$4, (var0) => { return new Paragraph(var0); });
        },
      );
      return $result.lazy_or(
        _pipe$4,
        () => {
          let _pipe$5 = $processing.from_html(html);
          return $result.map(
            _pipe$5,
            (var0) => { return new BlockProcessing(var0); },
          );
        },
      );
    },
  );
}

export function from_table(table) {
  let html = table.content;
  return $result.map(
    $table.from_html(html),
    (table) => { return toList([new Table(table)]); },
  );
}

export function from_outline(outline) {
  let paragraph = new Paragraph(
    new $p.Paragraph(
      $document_context.empty(),
      "p",
      toList([
        new $p.ParagraphRun(
          new $text.Run(
            toList([new $text.RunText(outline.content)]),
            new None(),
          ),
        ),
      ]),
      new $p.Left(),
      "Style de tableau 2",
      new $p.Metadata(new Some(new $kind.Question())),
      new None(),
    ),
  );
  return new Ok(toList([paragraph]));
}

export function from_question(question) {
  let _block;
  let $ = $question.get_textual_answers(question);
  if ($ instanceof $Empty) {
    _block = toList([""]);
  } else {
    let answers = $;
    _block = $list.map(answers, (a) => { return a.value; });
  }
  let answer_values = _block;
  return $result.map(
    $p.from_html(question.content),
    (question) => {
      let answers = $list.flat_map(
        answer_values,
        (answer) => {
          let $1 = $html_parser.as_tree(("<div>" + answer) + "</div>");
          let nodes;
          if ($1 instanceof $html_parser.StartElement) {
            nodes = $1;
          } else {
            throw makeError(
              "let_assert",
              FILEPATH,
              "data/docx",
              220,
              "from_question",
              "Pattern match failed, no pattern matched the value.",
              {
                value: $1,
                start: 6640,
                end: 6747,
                pattern_start: 6651,
                pattern_end: 6688
              }
            )
          }
          return $list.filter_map(
            nodes.children,
            (child) => {
              let html = $html_parser.render_html(child, 0);
              let _block$1;
              let _pipe = $hr.from_html(html);
              _block$1 = $result.map(
                _pipe,
                (var0) => { return new PageBreak(var0); },
              );
              let _pipe$1 = _block$1;
              let _pipe$2 = $result.lazy_or(
                _pipe$1,
                () => {
                  let _pipe$2 = $table.from_html(html);
                  return $result.map(
                    _pipe$2,
                    (var0) => { return new Table(var0); },
                  );
                },
              );
              let _pipe$3 = $result.lazy_or(
                _pipe$2,
                () => {
                  let _pipe$3 = $img.from_html(html);
                  return $result.map(
                    _pipe$3,
                    (var0) => { return new Image(var0); },
                  );
                },
              );
              let _pipe$4 = $result.lazy_or(
                _pipe$3,
                () => {
                  let _pipe$4 = $p.from_html(html);
                  return $result.map(
                    _pipe$4,
                    (var0) => { return new Paragraph(var0); },
                  );
                },
              );
              return $result.lazy_or(
                _pipe$4,
                () => {
                  let _pipe$5 = $processing.from_html(html);
                  return $result.map(
                    _pipe$5,
                    (var0) => { return new BlockProcessing(var0); },
                  );
                },
              );
            },
          );
        },
      );
      return listPrepend(new Paragraph(question), answers);
    },
  );
}

export function get_paragraph(element) {
  if (element instanceof PageBreak) {
    return new Error(undefined);
  } else if (element instanceof Paragraph) {
    let paragraph = element[0];
    return new Ok(paragraph);
  } else if (element instanceof Table) {
    return new Error(undefined);
  } else if (element instanceof Image) {
    return new Error(undefined);
  } else {
    return new Error(undefined);
  }
}

export function is_numbered(element) {
  if (element instanceof PageBreak) {
    return false;
  } else if (element instanceof Paragraph) {
    let p = element[0];
    return $result.is_ok($p.list_format(p));
  } else if (element instanceof Table) {
    return false;
  } else if (element instanceof Image) {
    return false;
  } else {
    return false;
  }
}

function do_handle_lists(loop$elements, loop$res) {
  while (true) {
    let elements = loop$elements;
    let res = loop$res;
    if (elements instanceof $Empty) {
      return res;
    } else {
      let $ = elements.head;
      if ($ instanceof PageBreak) {
        let el = $;
        let rest = elements.tail;
        loop$elements = rest;
        loop$res = listPrepend(el, res);
      } else if ($ instanceof Paragraph) {
        let el = $;
        let rest = elements.tail;
        let p = $[0];
        let $1 = $p.list_format(p);
        if ($1 instanceof Ok) {
          let tag = $1[0];
          let _block;
          let _pipe = elements;
          let _pipe$1 = $list.take_while(_pipe, is_numbered);
          let _pipe$2 = $list.filter_map(_pipe$1, get_paragraph);
          let _pipe$3 = $list.map(_pipe$2, $p.as_list_item);
          _block = $list.map(
            _pipe$3,
            (var0) => { return new $p.ParagraphListItem(var0); },
          );
          let children = _block;
          let rest$1 = $list.drop(rest, $list.length(children) - 1);
          loop$elements = rest$1;
          loop$res = (() => {
            let _pipe$4 = new $p.Paragraph(
              p.doc_context,
              tag,
              children,
              p.alignment,
              p.original_style,
              p.metadata,
              p.numbering_props,
            );
            let _pipe$5 = new Paragraph(_pipe$4);
            return ((_capture) => { return $list.prepend(res, _capture); })(
              _pipe$5,
            );
          })();
        } else {
          loop$elements = rest;
          loop$res = listPrepend(el, res);
        }
      } else if ($ instanceof Table) {
        let el = $;
        let rest = elements.tail;
        loop$elements = rest;
        loop$res = listPrepend(el, res);
      } else if ($ instanceof Image) {
        let el = $;
        let rest = elements.tail;
        loop$elements = rest;
        loop$res = listPrepend(el, res);
      } else {
        let el = $;
        let rest = elements.tail;
        loop$elements = rest;
        loop$res = listPrepend(el, res);
      }
    }
  }
}

export function handle_lists(docx) {
  return new Docx(
    docx.language,
    (() => {
      let _pipe = docx.elements;
      let _pipe$1 = do_handle_lists(_pipe, toList([]));
      return $list.reverse(_pipe$1);
    })(),
  );
}

function expand_list_element_for_proposal(element) {
  if (element instanceof Paragraph) {
    let p = element[0];
    if ((p.tag === "ul") || (p.tag === "ol")) {
      let question_items = $list.filter_map(
        p.children,
        (child) => {
          if (child instanceof $p.ParagraphListItem) {
            let item = child[0];
            let item_kind = $p.list_item_kind(item, p);
            if (item_kind instanceof $kind.Question) {
              return new Ok(new Paragraph($p.update_kind(item, item_kind)));
            } else {
              return new Error(undefined);
            }
          } else {
            return new Error(undefined);
          }
        },
      );
      if (question_items instanceof $Empty) {
        return toList([element]);
      } else {
        return question_items;
      }
    } else {
      return toList([element]);
    }
  } else {
    return toList([element]);
  }
}

export function expand_lists_for_proposal(elements) {
  return $list.flat_map(elements, expand_list_element_for_proposal);
}

function update_list_paragraph_kind(parent, target_index, kind) {
  let children = $list.map(
    parent.children,
    (child) => {
      if (child instanceof $p.ParagraphListItem) {
        let item = child[0];
        if (item.doc_context.index === target_index) {
          return new $p.ParagraphListItem($p.update_kind(item, kind));
        } else {
          return child;
        }
      } else {
        return child;
      }
    },
  );
  let updated = !isEqual(children, parent.children);
  if (updated) {
    return new Ok(
      new $p.Paragraph(
        parent.doc_context,
        parent.tag,
        children,
        parent.alignment,
        parent.original_style,
        parent.metadata,
        parent.numbering_props,
      ),
    );
  } else {
    return new Error(undefined);
  }
}

function update_kind_at_index_on_element(element, target_index, kind) {
  let $ = index(element);
  if ($ instanceof Some) {
    let i = $[0];
    if (i === target_index) {
      return new Ok(update_kind(element, kind));
    } else {
      if (element instanceof Paragraph) {
        let p = element[0];
        if ((p.tag === "ul") || (p.tag === "ol")) {
          let _pipe = update_list_paragraph_kind(p, target_index, kind);
          return $result.map(_pipe, (var0) => { return new Paragraph(var0); });
        } else {
          return new Error(undefined);
        }
      } else {
        return new Error(undefined);
      }
    }
  } else {
    if (element instanceof Paragraph) {
      let p = element[0];
      if ((p.tag === "ul") || (p.tag === "ol")) {
        let _pipe = update_list_paragraph_kind(p, target_index, kind);
        return $result.map(_pipe, (var0) => { return new Paragraph(var0); });
      } else {
        return new Error(undefined);
      }
    } else {
      return new Error(undefined);
    }
  }
}

export function update_kind_at_index(docx, target_index, kind) {
  return new Docx(
    docx.language,
    $list.map(
      docx.elements,
      (element) => {
        let $ = update_kind_at_index_on_element(element, target_index, kind);
        if ($ instanceof Ok) {
          let updated = $[0];
          return updated;
        } else {
          return element;
        }
      },
    ),
  );
}

function remove_virtual_paragraph(p) {
  return $bool.guard(
    !$p.is_virtual_paragraph(p),
    toList([p]),
    () => {
      return $list.filter_map(
        p.children,
        (child) => {
          if (child instanceof $p.ParagraphRun) {
            return new Error(undefined);
          } else if (child instanceof $p.ParagraphCheckbox) {
            return new Error(undefined);
          } else {
            let p$1 = child[0];
            return new Ok(
              new $p.Paragraph(
                p$1.doc_context,
                "p",
                p$1.children,
                p$1.alignment,
                p$1.original_style,
                p$1.metadata,
                p$1.numbering_props,
              ),
            );
          }
        },
      );
    },
  );
}

function remove_virtual_cell(cell) {
  return new $table.Cell(
    cell.index,
    $list.flat_map(
      cell.children,
      (content) => {
        if (content instanceof $table.Text) {
          return toList([content]);
        } else {
          let p = content[0];
          let _pipe = remove_virtual_paragraph(p);
          return $list.map(
            _pipe,
            (var0) => { return new $table.Paragraph(var0); },
          );
        }
      },
    ),
    cell.styles,
    cell.colspan,
    cell.rowspan,
  );
}

function remove_virtual_row(row) {
  return new $table.Row(
    row.index,
    row.is_header,
    $list.map(row.cells, remove_virtual_cell),
  );
}

export function remove_virtual_nodes(element) {
  if (element instanceof PageBreak) {
    return toList([element]);
  } else if (element instanceof Paragraph) {
    let p = element[0];
    let _pipe = remove_virtual_paragraph(p);
    return $list.map(_pipe, (var0) => { return new Paragraph(var0); });
  } else if (element instanceof Table) {
    let t = element[0];
    let rows = element[0].rows;
    return toList([
      new Table(
        new $table.Table(
          t.doc_context,
          t.tag,
          $list.map(rows, remove_virtual_row),
          t.metadata,
        ),
      ),
    ]);
  } else if (element instanceof Image) {
    return toList([element]);
  } else {
    return toList([element]);
  }
}

export function persist_new_metadata(docx, elements) {
  let _pipe = new Docx(
    docx.language,
    $list.map2(
      docx.elements,
      elements,
      (el1, el2) => {
        let idx1 = index(el1);
        let idx2 = index(el2);
        if (el1 instanceof PageBreak) {
          if (el2 instanceof PageBreak && isEqual(idx1, idx2)) {
            let p1 = el1[0];
            let p2 = el2[0];
            let _pipe = new $hr.PageBreak(
              p1.doc_context,
              p1.break_type,
              p1.html_tag,
              p2.metadata,
            );
            return new PageBreak(_pipe);
          } else {
            return el1;
          }
        } else if (el1 instanceof Paragraph) {
          if (el2 instanceof Paragraph && isEqual(idx1, idx2)) {
            let p1 = el1[0];
            let p2 = el2[0];
            let _pipe = new $p.Paragraph(
              p1.doc_context,
              p1.tag,
              p1.children,
              p1.alignment,
              p1.original_style,
              p2.metadata,
              p1.numbering_props,
            );
            return new Paragraph(_pipe);
          } else {
            return el1;
          }
        } else if (el1 instanceof Table) {
          if (el2 instanceof Table && isEqual(idx1, idx2)) {
            let p1 = el1[0];
            let p2 = el2[0];
            let _pipe = new $table.Table(
              p1.doc_context,
              p1.tag,
              p1.rows,
              p2.metadata,
            );
            return new Table(_pipe);
          } else {
            return el1;
          }
        } else if (el1 instanceof Image) {
          if (el2 instanceof Image && isEqual(idx1, idx2)) {
            let i1 = el1[0];
            let i2 = el2[0];
            let _pipe = new $img.Image(i1.doc_context, i1.html_tag, i2.metadata);
            return new Image(_pipe);
          } else {
            return el1;
          }
        } else if (el2 instanceof BlockProcessing && isEqual(idx1, idx2)) {
          let i1 = el1[0];
          let i2 = el2[0];
          let _pipe = new $processing.BlockProcessing(
            i1.doc_context,
            i1.html_tag,
            i2.metadata,
          );
          return new BlockProcessing(_pipe);
        } else {
          return el1;
        }
      },
    ),
  );
  return handle_lists(_pipe);
}
